export const riskManagement = {
  redirect: '/gestao-de-risco/registrar',
  feature: 'risk_management',
};
export type TRiskManagementStatus =
  | 'CREATED'
  | 'IN_ANALYSIS'
  | 'CANCELED'
  | 'FAILED'
  | 'SECURITY_PROFILE_NO'
  | 'SECURITY_PROFILE_WITH'
  | 'WAITING_REGISTER'
  | 'WAITING_SELFIE'
  | 'PROCESSING'
  | 'MANUAL'
  | 'NOT_SEARCHED';

interface RiskStatus {
  id: number;
  description: string;
  status: TRiskManagementStatus;
}

const riskStatusArray: RiskStatus[] = [
  { id: 1, status: 'CREATED', description: 'Em Processamento' },
  { id: 2, status: 'IN_ANALYSIS', description: 'Em Análise' },
  { id: 3, status: 'CANCELED', description: 'Cancelado' },
  { id: 4, status: 'FAILED', description: 'Falha no Envio' },
  { id: 5, status: 'SECURITY_PROFILE_NO', description: 'Necessário Atualização' },
  { id: 6, status: 'SECURITY_PROFILE_WITH', description: 'Com Perfil Securitário' },
  { id: 7, status: 'WAITING_REGISTER', description: 'Aguardando Cadastro' },
  { id: 8, status: 'WAITING_SELFIE', description: 'Aguardando Selfie' },
  { id: 9, status: 'PROCESSING', description: 'Em Processamento' },
  { id: 10, status: 'MANUAL', description: 'Inclusão Manual' },
  { id: 11, status: 'NOT_SEARCHED', description: 'Não Pesquisado' },
];

export const riskManagementStatus = riskStatusArray.reduce((acc, status) => {
  acc[status.status] = status;
  return acc;
}, {} as Record<TRiskManagementStatus, RiskStatus>);

export const riskManagementTextMap = {
  validApproval: {
    titleLabel: 'Consultar motorista',
    link: '/gestao-de-risco/registrar?motorista=ABC&frete=DEF&partner=',
    buttonLabel: 'Consultar agora',
  },
  notValidApproval: {
    titleLabel: 'Cadastrar motorista',
    link: '/gestao-de-risco/registrar?motorista=ABC&frete=DEF&partner=',
    buttonLabel: 'Cadastrar agora',
  },
};

export enum PARTNER {
  skymark = 'Skymark',
  guep = 'GUEP',
}
